import React from 'react';
import { createRoot } from 'react-dom/client';
import SelectAccountMode from '../screens/parent/select-account-mode';
// global css loaded
import '../../css/dist/select-account-type.scss';


const App = () => {
    return <SelectAccountMode/>
}

// [AI GENERATED CODE] Updated to React 19 createRoot API
const root = createRoot(document.getElementById('select-account-type'));
root.render(<App/>);